import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Translation, TranslocoLoader, TRANSLOCO_LOADER } from '@jsverse/transloco';
import { catchError, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private _http: HttpClient) { }

  getTranslation(langPath: string) {
    return this._http.get<Translation>(`/assets/i18n/${langPath}.json`).pipe(
      catchError((error) => {
        console.warn(`Failed to load translation for ${langPath}:`, error);
        // Return empty object as fallback
        return of({});
      })
    );
  }
}

export const availableLangs = ['nl', 'en'];

export const scopeLoader = (importer: any, root = 'i18n') => {
  return availableLangs.reduce((acc: any, lang) => {
    acc[lang] = () => {
      return importer(lang, root).catch((error: any) => {
        console.warn(`Failed to load translation for ${lang}/${root}:`, error);
        
        // Check if it's a chunk loading error
        if (error.name === 'ChunkLoadError' || error.message?.includes('ChunkLoadError')) {
          console.warn(`Chunk loading failed for ${lang}/${root}, using fallback`);
          return Promise.resolve({});
        }
        
        // Retry once after a short delay for other errors
        return new Promise((resolve) => {
          setTimeout(() => {
            importer(lang, root)
              .then(resolve)
              .catch((retryError: any) => {
                console.error(`Retry failed for ${lang}/${root}:`, retryError);
                // Return empty object as fallback
                resolve({});
              });
          }, 100);
        });
      });
    };
    return acc;
  }, {});
};

export const translocoLoader = { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader };

